export default {
	styleOverrides: {
		root: ({ theme }) => ({
			backgroundColor:'transparent'
		}),
	},
}
